var _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "189 0 33 57",
    width: 33,
    height: 57,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fff;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{clip-path:url(#clip-path-3);}"))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    "data-name": "Fill 3",
    className: "cls-2",
    d: "M 201.51 0 L 195.2 28.42 L 189 57 L 197.52 57 L 203.69 28.42 L 210 0 L 201.51 0 Z",
    style: {
      paintOrder: "stroke markers",
      fill: "rgb(0, 97, 161)",
      transformOrigin: "199.5px 28.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    className: "cls-2",
    d: "M213.51,0,207.2,28.42,201,57h8.53l6.16-28.58L222,0Z",
    style: {
      fill: "rgb(0, 97, 161)"
    },
    transform: "matrix(1, 0, 0, 1, 7.105427357601002e-15, 0)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimalLogo);
export default __webpack_public_path__ + "static/media/minimal-logo.211a0a5a822ea7f6572ca4b8c9ea89d0.svg";
export { ForwardRef as ReactComponent };